import { render, staticRenderFns } from "./TVPPrePaymentChangeForm.vue?vue&type=template&id=051fba01&"
import script from "./TVPPrePaymentChangeForm.vue?vue&type=script&lang=js&"
export * from "./TVPPrePaymentChangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports